import AddBeneficiaryError from './AddBeneficiaryError';
class InvestorHasAuthenticationFactorLocked extends AddBeneficiaryError {
    constructor(options) {
        super('The investor second authentication factor is temporarily locked', options);
    }
}
export default InvestorHasAuthenticationFactorLocked;
